import { render, staticRenderFns } from "./OP_Trending.vue?vue&type=template&id=7d0fd40c&scoped=true&"
import script from "./OP_Trending.vue?vue&type=script&lang=js&"
export * from "./OP_Trending.vue?vue&type=script&lang=js&"
import style0 from "./OP_Trending.vue?vue&type=style&index=0&id=7d0fd40c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0fd40c",
  null
  
)

export default component.exports